import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-[#f5f5f5] py-10 md:py-16 px-4 border-t-4 border-gray-300" data-id="element-224">
      <div className="max-w-3xl mx-auto" data-id="element-225">
        <div className="bg-white p-6 md:p-12 rounded-lg border-l-8 border-[#c41e3a] shadow-lg" data-id="element-226">
          <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-2 leading-tight" data-id="element-227">
            Muchos quieren aprender barbería.
          </h2>
          <p className="text-xl md:text-3xl font-black text-[#c41e3a] mb-6 leading-tight" data-id="element-228">
            Pero pocos lo hacen con método.
          </p>
          <div className="w-12 h-0.5 bg-[#c41e3a] mb-6" data-id="element-229"></div>

          <div className="space-y-4" data-id="element-230">
            <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-231">
              La mayoría intenta aprender viendo videos sueltos o copiando lo
              que ve en redes.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed font-semibold" data-id="element-232">
              El problema es que sin estructura, el progreso se vuelve lento y
              confuso.
            </p>
            <p className="text-base md:text-lg text-gray-900 leading-relaxed font-black mt-6" data-id="element-233">
              Método Barber Pro fue creado para resolver eso.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-234">
              Una formación clara, organizada y pensada para que desarrolles
              técnica real paso a paso.
            </p>
          </div>
        </div>
      </div>
    </section>;
}